import type { Lead } from "@/types/lead";

/** Open follow-up whose due time is in the past (overdue) or anytime calendar-today (local). */
export function isOpenFollowUpDueTodayOrOverdue(dueIso: string): boolean {
  const due = new Date(dueIso);
  if (Number.isNaN(due.getTime())) return false;
  const now = new Date();
  if (due.getTime() < now.getTime()) return true;
  return (
    due.getFullYear() === now.getFullYear() &&
    due.getMonth() === now.getMonth() &&
    due.getDate() === now.getDate()
  );
}

export function countFollowUpsNeedingAttention(leads: Lead[]): number {
  let n = 0;
  for (const lead of leads) {
    if (lead.isTest) continue;
    for (const f of lead.follow_ups ?? []) {
      if (f.status !== "open") continue;
      if (isOpenFollowUpDueTodayOrOverdue(f.due_date)) n += 1;
    }
  }
  return n;
}
